import { SettingsPageComponent } from "./settings-page.component";
import { SettingsActionsModalComponent } from "./settingsActionsModal/settings-actions-modal.component";
export const SettingsPageModule = angular
    .module('settingsPage', [])
    .config(['$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('missioncontrol.settings', {
            url: '/settings',
            component: SettingsPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                accessMode: null
            }
        });
    }
])
    .component(SettingsPageComponent.selector, SettingsPageComponent.component)
    .component(SettingsActionsModalComponent.selector, SettingsActionsModalComponent.component)
    .name;
//# sourceMappingURL=settings-page.module.js.map